import { RefObject } from 'react';

export enum ToastType {
  Global = 'global',
  Target = 'target',
}

export type TToastStyle = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8';

export interface IToastOptions {
  type?: ToastType;
  durationMs: number;
  targetRef?: RefObject<HTMLElement>;
  style?: TToastStyle;
}
